/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Find_PlayerInputs */



/**
* | output |
* | --- |
* | "Find a player" |
*
* @param {Rounds_Find_PlayerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_find_player = /** @type {((inputs?: Rounds_Find_PlayerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Find_PlayerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Trouver un joueur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Buscar un jugador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Encontrar um jogador")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trova un giocatore")
	return /** @type {LocalizedString} */ ("Find a player")
});